import React, { useState, useEffect } from "react";
import { useGetUsersIntegration } from "@/features/user/hooks/use-get-integration";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { PasswordForm } from "@/shared/components/text-box/password-form";
import { useUsersIntegrationContext } from "@/features/user/contexts/users-integration-context";

interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

// 利用者統合モーダル
export const UserIntegrationInputModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    ownerId,
    password,
    setOwnerId,
    setPassword,
    setRegisteredPassbooks,
  } = useUsersIntegrationContext();
  const {
    getUsersIntegration,
  } = useGetUsersIntegration();
  const [isActiveIntegrationButton, setIsActiveIntegrationButton] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");

  useEffect(() => {
    setIsActiveIntegrationButton(ownerId !== "" && password !== "");
  }, [ownerId, password]);

  const handleClose = () => {
    setOwnerId("");
    setPassword("");
    setPasswordErrorMessage("");
    onTapCloseModal();
  };

  return (
    <BasePageModal
      title="ユーザーの統合"
      className="md-user-integrat"
      handleClose={handleClose}
      bottomChildren={
        <BaseRoundButton
          buttonText="次へ"
          onClick={async() => {
            const res = await getUsersIntegration(ownerId, password);
            if (res === undefined) return;
            if ("errorMessage" in res) {
              setPasswordErrorMessage(res.errorMessage);
              return;
            }
            if (res.length > 0) {
              setRegisteredPassbooks(res);
            }
            setPasswordErrorMessage("");
            onTapCompleteModal();
          }}
          isActive={isActiveIntegrationButton}
        />
      }
      disableOverlayClose={true}
    >
      <h2>
        統合したいユーザー情報を入力
      </h2>
      <ul>
        <li>
        <MailAddressForm
          className="required"
          id="userId"
          title="メールアドレス(利用者ID)"
          placeholder="統合したいユーザーのメールアドレス"
          onChange={(value) => setOwnerId(value)}
        />
        </li>
        <li>
          <PasswordForm
            className="required"
            id="password"
            title="パスワード"
            placeholder="半角英数字8文字以上"
            onChange={(value) => {
              setPassword(value);
              setPasswordErrorMessage("");
            }}
          />
        </li>
        {passwordErrorMessage && <span className="pass_error">{passwordErrorMessage}</span>}
      </ul>
      <div className="message">
        <p>インストールアプリ版のMoneyLinkでコンバートを行ったデータのうち、Web版でのメールアドレス認証が完了していないユーザーのデータを現在の利用者に統合することができます。</p>
        <p>コンバートを行った後に、Web版でのメールアドレス認証を完了しているユーザーのデータは統合することができません。</p>
        <p>また、一度ユーザーを統合すると元の状態には戻せなくなりますのでご注意ください。</p>
      </div>
    </BasePageModal>
  );
};
